var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouritesIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4854 14.0603C9.8021 13.8702 10.1979 13.8702 10.5146 14.0603L14.3848 16.383L13.3597 12.0145C13.2745 11.6517 13.3982 11.2716 13.6806 11.0283L17.0813 8.09895L12.6014 7.72125C12.2323 7.69015 11.9107 7.45765 11.7655 7.11695L10 2.97471L8.2345 7.11695C8.0893 7.45765 7.76766 7.69015 7.3986 7.72125L2.9187 8.09895L6.31942 11.0283C6.60177 11.2716 6.72545 11.6517 6.64032 12.0145L5.61523 16.383L9.4854 14.0603ZM9.0415 0.632741C9.4006 -0.208309 10.5994 -0.208309 10.9585 0.632741L13.2325 5.96811L19.0458 6.45814C19.963 6.53515 20.3352 7.67225 19.6392 8.27125L15.2229 12.0756L16.5495 17.729C16.7587 18.62 15.7861 19.3231 14.9976 18.85L10 15.8508L5.00238 18.85C4.21387 19.3231 3.2413 18.62 3.4505 17.729L4.77709 12.0756L0.360809 8.27125C-0.335181 7.67225 0.036949 6.53515 0.954199 6.45814L6.76749 5.96811L9.0415 0.632741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesIcons);
export default __webpack_public_path__ + "static/media/Favourites Icons.f49762edb8c3d93218c429209ceebe84.svg";
export { ForwardRef as ReactComponent };